import React, { useState } from 'react'

export const Input = ({
  id,
  placeholder = ' ',
  type = 'text',
  value = '',
  disabled,
  error = false,
  errorText = '',
  update = () => {},
  additionalClass = '',
  label = '',
  userFormInput = false,
  valueRef = null,
  ...otherProps
}) => {
  const onChange = ({ value }) => {
    update(value)
  }
  const fieldClassName = userFormInput
    ? 'foundry--input-fields user-form--input'
    : 'foundry--input-fields'
  return (
    <div className="foundry--input-fields-wrapper">
      <div className={`${fieldClassName} ${error ? 'foundry--field-error' : ''}`}>
        <input
          id={id}
          className={`input-fields__input ${additionalClass} ${
            error ? 'invalid' : ''
          }`}
          type={type}
          placeholder={placeholder}
          value={value === null ? '' : value}
          disabled={disabled}
          onChange={({ target = { value: '' } }) => onChange(target)}
          ref={valueRef}
          {...otherProps}
        />
        {label && (
          <label className="input-fields__label" htmlFor={id}>
            {label}
          </label>
        )}
        {error && (
          <div className="field-error--wrap">
            <i className="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
            <span className="field-error--message">{errorText}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export const PlaceholderInput = ({
  label = '',
  name = label,
  placeholder,
  value = '',
  update = value => {},
  error = false,
  type = 'text',
}) => {
  const [inputValue, updateInputValue] = useState(value)
  const onChange = ({ value }) => {
    update(value)
    updateInputValue(value)
  }

  const PlaceholderInputWithoutError = (
    <div className="input-group label-floating">
      <input
        name={name}
        placeholder={placeholder}
        className="input input--placeholder"
        type={type}
        value={inputValue}
        onChange={({ target = { value: '' } }) => onChange(target)}
      />
      <label htmlFor={name}>{label}</label>
    </div>
  )

  const PlaceholderInputWithError = (
    <div className="input-group label-floating">
      <input
        name={name}
        placeholder={placeholder}
        className="input input--placeholder--validation--error"
        type={type}
        value={inputValue}
        onChange={({ target = { value: '' } }) => onChange(target)}
      />
      <label htmlFor={name}>{label}</label>
      <i className="fa fa-exclamation-triangle error-icon"></i>
    </div>
  )
  return error ? PlaceholderInputWithError : PlaceholderInputWithoutError
}
export const TextArea = ({
  id,
  placeholder,
  value = '',
  type = 'text',
  disabled,
  rows = 5,
  error = false,
  errorText = 'This field is required',
  update = () => {},
  additionalClass = '',
  label = '',
  userFormInput = false,
  ...otherProps
}) => {
  const onChange = ({ value }) => {
    update(value)
  }
  const fieldClassName = userFormInput
    ? 'foundry--input-fields user-form--input'
    : 'foundry--input-fields'
  return (
    <div className="foundry--input-fields-wrapper">
      <div className={`${fieldClassName} ${error ? 'foundry--field-error' : ''}`}>
        <textarea
          id={id}
          className={`input-fields__textarea ${additionalClass} ${
            error ? 'invalid' : ''
          }`}
          type={type}
          rows={rows}
          disabled={disabled}
          value={value || ''}
          placeholder={placeholder}
          onChange={({ target = { value: '' } }) => onChange(target)}
          {...otherProps}
        ></textarea>
        <label className="input-fields__label" htmlFor={id}>
          {label}
        </label>
        {error && (
          <div className="field-error--wrap">
            <i className="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
            <span className="field-error--message">{errorText}</span>
          </div>
        )}
      </div>
    </div>
  )
}
export const RangeInput = ({
  id,
  placeholder,
  disabled,
  value,
  error = false,
  errorType = '',
  update = () => {},
  label,
  additionalClass = '',
  additionalErrorClass,
  inputLabelWrap = false,
  ...otherProps
}) => {
  const onChange = ({ value }) => {
    update(value)
  }
  const errorMessage = label => {
    const error = {
      Minimum: "Value can't be higher than the Maximum",
      Maximum: "Value can't be lower than the Minimum",
    }
    return error[label]
  }
  const fieldClassName = inputLabelWrap
    ? 'foundry--input-fields input-label-wrap'
    : 'foundry--input-fields'
  return (
    <div className="foundry--input-fields-wrapper">
      <div className={`${fieldClassName} ${error ? 'foundry--field-error' : ''}`}>
        <input
          id={id}
          className={`input-fields__input ${additionalClass} ${
            error ? 'invalid' : ''
          }`}
          type="text"
          placeholder={placeholder}
          value={value || ''}
          disabled={disabled}
          onChange={({ target = { value: '' } }) => onChange(target)}
          onBlur={() => {
            errorType == 'num' ? update('') : ''
          }}
          {...otherProps}
        />
        <label className="input-fields__label" htmlFor={id}>
          {label}
        </label>
        {error && (
          <div className="field-error--wrap">
            <i className="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
            <span className={`field-error--message ${additionalErrorClass}`}>
              {errorType == 'char'
                ? 'Please enter a valid number'
                : errorType == 'num'
                ? errorMessage(label)
                : ''}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export const PhoneNumberInput = ({
  label,
  placeholder,
  value,
  update = value => {},
  error,
}) => {
  const onChange = ({ value }) => {
    update(value)
  }
  return (
    <div className="input-group label-floating">
      <input
        placeholder={placeholder}
        className={`input ${
          error ? 'input--placeholder--validation--error' : 'input--placeholder'
        }`}
        type="text"
        value={value}
        onChange={({ target = { value: '' } }) => onChange(target)}
      />
      <label>{label}</label>
      {error ? <i className="fa fa-exclamation-triangle error-icon"></i> : ''}
    </div>
  )
}

export default Input
